type Entity = {
  outstandingLoanBalance: number
}

export const debtsSum = (debts: Entity[]): number => {
  return debts.reduce((total, entity) => {
    return total + entity.outstandingLoanBalance
  }, 0)
}
